export const gItemEnum = [
  "text", // 0
  "icon", // 1
  "graphic", // 2
  "photo", // 3
  "video", // 4
  "signature", // 5
  "page_break", // 6
  "product_service", // 7
  "product_service_total", // 8
  "payment", // 9
  "background", // 10
  "text_total" // 11
];

export const SIGNS = ["contact", "tenant"];

export const G_ITEM_STATE = ["initial", "dragging", "dropped"];


export const textTotalDefaultValue = "<table style=\"border-collapse: collapse; width: 100%; border-width: 1px; border-spacing: 2px; height: 163px;\" border=\"1\"><colgroup><col style=\"width: 50.1813%;\"><col style=\"width: 49.8215%;\"></colgroup>\n" +
  "<tbody>\n" +
  "<tr style=\"height: 38px;\">\n" +
  "<td style=\"padding: 4px; text-align: right;\"><span style=\"font-family: Roboto;\">Sub Total</span></td>\n" +
  "<td style=\"padding: 4px; text-align: right;\"><span style=\"opacity: 1;\">[Document.Subtotal]</span></td>\n" +
  "</tr>\n" +
  "<tr style=\"height: 38px;\">\n" +
  "<td style=\"padding: 4px; text-align: right;\"><span style=\"font-family: Roboto;\">Shipping</span></td>\n" +
  "<td style=\"padding: 4px; text-align: right;\"><span style=\"font-family: Roboto;\"><span style=\"opacity: 1;\">[Document.Shipping]</span></span></td>\n" +
  "</tr>\n" +
  "<tr style=\"height: 38px;\">\n" +
  "<td style=\"padding: 4px; text-align: right;\"><span style=\"font-family: Roboto;\">Sales Tax (<span style=\"opacity: 1;\">[Document.Sales Tax Name]</span> <span style=\"opacity: 1;\">[Document.Sales Tax Rate]</span>)</span></td>\n" +
  "<td style=\"padding: 4px; text-align: right;\"><span style=\"opacity: 1;\"><span style=\"opacity: 1;\">[Document.Sales Tax Amount]</span></span></td>\n" +
  "</tr>\n" +
  "<tr style=\"height: 38px;\">\n" +
  "<td style=\"padding: 4px; text-align: right;\"><span style=\"font-family: Roboto;\"><strong>Grand Total</strong></span></td>\n" +
  "<td style=\"padding: 4px; text-align: right;\"><span style=\"font-family: Roboto;\"><strong><span style=\"opacity: 1;\">[Document.Grand Total]</span></strong></span></td>\n" +
  "</tr>\n" +
  "</tbody>\n" +
  "</table>";